import { io } from "socket.io-client";

let socket;
const projectMode = process.env.REACT_APP_PROJECT_MODE;
const devSocketUrl = process.env.REACT_APP_SOCKET_URL_FOR_DEV;
const prodSocketUrl = process.env.REACT_APP_SOCKET_URL_FOR_PROD;

// Only initialize socket if URL is available
if (projectMode === "development" && devSocketUrl) {
  socket = io(devSocketUrl);
} else if (prodSocketUrl) {
  socket = io(prodSocketUrl);
} else {
  // Create a dummy socket that won't crash the app
  console.warn("Socket.IO URL not configured. Socket functionality will be disabled.");
  socket = {
    on: () => {},
    off: () => {},
    emit: () => {},
    connect: () => {},
    disconnect: () => {},
    connected: false,
  };
}

export default socket;
